import { Expr } from "../../Expr";
import { binaryExpr, BinaryExprStructure } from "../../BinaryExpr";

export interface EqualsXpr extends BinaryExprStructure {
  $type: "==";
  left: Expr;
  right: Expr;
}

export const equalsExpr = (left: Expr, right: Expr): EqualsXpr => {
  return binaryExpr("==", left, right) as EqualsXpr;
};
